/* eslint-disable */
import Vue from 'vue';
import { Consts, Http, UploadService, } from 'gw-js-lib';
import { isEmpty } from 'lodash';
import store from '@/store';


function returnCourse() {
  if (!isEmpty(store.state.course)) {
    return store.state.course;
  }
}

// ------------------------------------------- Start User Services ----------------------------
const VUE_APP_API_USER = process.env.VUE_APP_API_USER;

export const login = ({ email, password }) => (
  Http({
    url: `${VUE_APP_API_USER}/auth/v2`,
    method: 'post',
    body: { username: email, password },
    showError: true,
    errorList: { '1': Consts.Context.APP.$t('login.invalidCredentials') },
  })
);

export const recoverPassword = (token, password) => (
  Http({
    url: `${VUE_APP_API_USER}/recover-password/${token}`,
    method: 'post',
    body: { password },
    showError: true,
    errorList: {},
  })
);

export const disableAlerts = (token) => (
  Http({
    url: `${VUE_APP_API_USER}/disable-alert/${token}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const changePassword = (currentPassword, newPassword) => (
  Http({
    url: `${VUE_APP_API_USER}/change-password`,
    method: 'post',
    body: { 
      password: currentPassword,
      new_password: newPassword
     },
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('settings.wrongPassword'),
    },
  })
);

export const requesToken = ({ username }) => (
  Http({
    url: `${VUE_APP_API_USER}/forgot-password`,
    method: 'post',
    body: { username },
    showError: true,
    errorList: {},
  })
);

export const logout = () => {
  return new Promise((resolve, reject) => {
    return resolve({ status: 200 });
  });
};

export const getMe = () => (
  Http({
    url: `${VUE_APP_API_USER}/me`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const saveUser = (data) => (
  Http({
    url: `${VUE_APP_API_USER}/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { 
      '105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      '106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  })
);

export const updateUser = (data, id) => (
  Http({
    url: `${VUE_APP_API_USER}/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { 
      '105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      '106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('settings.profileUpdated'),
    });
    return response;
  })
);

export const updateMe = (data, showSuccessMessage) => (
  Http({
    url: `${VUE_APP_API_USER}/me`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { 
      '105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      '106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  }).then((response) => {
    if (showSuccessMessage) {
      Vue.notify({
        type: 'success',
        text: Consts.Context.APP.$t('settings.profileUpdated'),
      });
    }
    return response;
  })
);

export const getUser = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/${id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const deleteUser = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/${id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: `${response.name} ${response.last_name} ` + Consts.Context.APP.$t('users.wasDeleted'),
    });
    return response;
  })
);

export const getUsers = (course_id) => (
  Http({
    url: `${VUE_APP_API_USER}/allbycourse/${course_id ? course_id : returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getUsersCustomer = (course_id) => (
  Http({
    url: `${VUE_APP_API_USER}/bycourse/${course_id ? course_id : returnCourse().course_id}/customer`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getAllUsers = () => (
  Http({
    url: `${VUE_APP_API_USER}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getAllUsersV2 = (page, rows, filters) => (
  Http({
    url: `${VUE_APP_API_USER}/page-v2/?page=${page}&rows=${rows}${filters}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const searchAllUsersV2 = (page, rows, filters) => (
  Http({
    url: `${VUE_APP_API_USER}/search-v2/?page=${page}&rows=${rows}${filters}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getUserFacilities = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/${id}/facilities`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const uploadUserPhoto = (user_id, formData, percentCompleted) => (
  UploadService().put(`${VUE_APP_API_USER}/${user_id}/photo`, formData, {
    onUploadProgress: progressEvent => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  })
);
export const uploadPhotoNewUser = (formData, percentCompleted) => (
  UploadService().post(`${VUE_APP_API_USER}/photo`, formData, {
    onUploadProgress: progressEvent => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  })
);
/**
 * Current version to upload a new photo to the User
 * @param {*} user_id 
 * @param {*} photo Object {file, name}
 */
export const uploadUserPhotoV2 = (user_id, photo) => {
  const formData = new FormData();
  formData.append('photo', photo.file, photo.name);
  return (
    UploadService().put(`${VUE_APP_API_USER}/${user_id}/photo/v2`, formData).then((resPhoto) => {
      return (resPhoto && resPhoto.data) ? resPhoto.data.data : null;
    })
  ); 
}

export const getNotifications = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/${id}/notification`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);
export const updateNotifications = (notifications) => (
  Http({
    url: `${VUE_APP_API_USER}/notification`,
    method: 'put',
    body: notifications,
    showError: true,
    errorList: {},
  })
);

export const validateUsernameAndEmail = (username, email) => (
  Http({
    url: `${VUE_APP_API_USER}/validate-username`,
    method: 'put',
    body: {username: username, email: email},
    showError: true,
    errorList: { 
      '105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      '106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  })
);

export const findUserByUsernameOrEmail = (username) => (
  Http({
    url: `${VUE_APP_API_USER}/username/${encodeURI(username)}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { 
      '20': Consts.Context.APP.$t('users.userNotFound'),
    },
  })
);

export const getKnowledgeBase = () => (
  Http({
    url: `${VUE_APP_API_USER}/knowledge-base`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const addKnowledgeCategory = (data) => (
  Http({
    url: `${VUE_APP_API_USER}/knowledge-base/category`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('knowledgeBase.categoryCreated'),
    });
    return response;
  })
);

export const updateKnowledgeCategory = (data, id) => (
  Http({
    url: `${VUE_APP_API_USER}/knowledge-base/category/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('knowledgeBase.categoryUpdated'),
    });
    return response;
  })
);

export const moveSensors = (data, course_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensors`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    return response;
  })
  .catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.sensorMoveError'),
    })
  })
);

export const deleteKnowledgeCategory = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/knowledge-base/category/${id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('knowledgeBase.categoryDeleted'),
    });
    return response;
  })
);

export const addKnowledgeFile = (id, formData, percentCompleted) => (
  UploadService().post(`${VUE_APP_API_USER}/knowledge-base/category/${id}/file`, formData, {
    onUploadProgress: progressEvent => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  })
);

export const updateKnowledgeFile = (data, id) => (
  Http({
    url: `${VUE_APP_API_USER}/knowledge-base/file/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('knowledgeBase.fileUpdated'),
    });
    return response;
  })
);

export const deleteKnowledgeFile = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/knowledge-base/file/${id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('knowledgeBase.fileDeleted'),
    });
    return response;
  })
);

export const userMonitoring = () => (
  Http({
    url: `${VUE_APP_API_USER}/monitoring`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

export const hideUser = (userId, courseId, hidden) => (
  Http({
    url: `${VUE_APP_API_USER}/${userId}/hide`,
    method: 'put',
    body: {
      "course_id": courseId,
      "hidden": hidden
    },
    showError: true,
    errorList: { },
  })
);

export const markUserAsContact = (userId, courseId, isContact) => (
  Http({
    url: `${VUE_APP_API_USER}/${userId}/is-contact`,
    method: 'put',
    body: {
      "course_id": courseId,
      "is_contact": isContact
    },
    showError: true,
    errorList: { },
  })
);

export const setDefaultPassword = (user_id) => (
  Http({
    url: `${VUE_APP_API_USER}/${user_id}/reset-password`,
    method: 'put',
    body: null,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('settings.passwordUpdated'),
    });
    return response;
  })
);

export const upgradeProspect = (data, id) => (
  Http({
    url: `${VUE_APP_API_USER}/${id}/prospect-upgrade`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { 
      '105': Consts.Context.APP.$t('users.emailAlreadyRegistered'),
      '106': Consts.Context.APP.$t('users.usernameAlreadyRegistered'),
    },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('settings.profileUpdated'),
    });
    return response;
  })
);

export const getAllNewsletter = () => (
  Http({
    url: `${VUE_APP_API_USER}/newsletter/all`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getActiveNewsletter = () => (
  Http({
    url: `${VUE_APP_API_USER}/newsletter`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const addNewsletter = (data) => (
  Http({
    url: `${VUE_APP_API_USER}/newsletter`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('newsletter.messageAdded'),
    });
    return response;
  })
);

export const updateNewsletter = (data, id) => (
  Http({
    url: `${VUE_APP_API_USER}/newsletter/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('newsletter.messageEdited'),
    });
    return response;
  })
);

export const deleteNewsletter = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/newsletter/${id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('newsletter.messageDeleted'),
    });
    return response;
  })
);

export const setNewsletterAsSeen = (id) => (
  Http({
    url: `${VUE_APP_API_USER}/newsletter/${id}/seen`,
    method: 'put',
    body: null,
    showError: false,
    errorList: {},
  })
);  

// ------------------------------------------- END User Services ----------------------------



// ------------------------------------------- Start Golf-Course Services ----------------------------
const VUE_APP_API_COURSE = process.env.VUE_APP_API_COURSE;

export const saveGolfCourse = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    return response;
  })
);

export const saveHole = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/hole/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('general.infoSaved'),
    });
    return response;
  })
);

export const updateHole = (data, id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/hole/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('general.infoUpdated'),
    });
    return response;
  })
);

export const getHole = (id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/hole/${id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getHoles = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/hole/bycourse/${returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getCourse = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const saveCourse = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('facility.facilitySaved'),
    });
    return response;
  })
);

export const updateCourse = (id, data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({ type: 'success', text: Consts.Context.APP.$t('facility.facilityUpdated') });
    return response;
  })
);

export const updateCourseShopAddress = (id, data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${id}/add-shop-address`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({ type: 'success', text: Consts.Context.APP.$t('facility.facilityUpdated') });
    return response;
  })
);

export const updateCourseFacilityNotes = (id, data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${id}/add-facility-notes`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  }).then((response) => {
    Vue.notify({ type: 'success', text: Consts.Context.APP.$t('facility.facilityUpdated') });
    return response;
  })
);



export const uploadGolfImages = (course_id, formData, type, percentCompleted) => (
  UploadService().put(`${VUE_APP_API_COURSE}/${course_id ? course_id : returnCourse().course_id}/${type}`, formData, {
    onUploadProgress: progressEvent => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  })
);
export const deleteBackgroundImage = (imageId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${returnCourse().course_id}/background/${imageId}`,
    method: 'delete',
    showError: true,
    errorList: {},
  })
);

export const getWeatherStations = (course_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id ? course_id : returnCourse().course_id}/weather/station/`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getWeatherThresholds = (station_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${station_id}/thresholds`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const updateWeatherThresholds = (station_id, data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${station_id}/thresholds`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  })
);

export const saveWeatherStation = (course_id, data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/weather/station/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: {},
  })
);

export const updateWeatherStation = (station_id, data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${station_id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: {},
  })
);

export const validateSnStationAvailable = (device_sn) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${device_sn}/validate`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { 
      '300': Consts.Context.APP.$t('weatherStation.snNotAvailable'),
    },
  })
);

export const deleteWeatherStation = (device_sn) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${device_sn}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const deleteWeatherStationById = (station_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/byid/${station_id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getLocalWeather = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${returnCourse().course_id}/weather/local/last-reading`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getLocalWeatherReportData = (data) => {

  let url =`${VUE_APP_API_COURSE}/${returnCourse().course_id}/weather/local/report?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}` 
  
  if(data.startDate && data.endDate){
    url = `${VUE_APP_API_COURSE}/${returnCourse().course_id}/weather/local/report/between-dates?from_date=${data.startDate}&until_date=${data.endDate}`
  }

  return Http({
    url, 
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
}

export const saveUserGolfCourse = (courseId, userId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${courseId}/user/${userId}`,
    method: 'post',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const deleteUserGolfCourse = (courseId, userId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${courseId}/user/${userId}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getMicroWeather = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${returnCourse().course_id}/weather/stations/last-reading`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getPrecipitationTotals = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/${returnCourse().course_id}/weather/stations/precipitation-totals`,
    method: 'get',
    body: null,
    showError: true,
    errorList: {},
  })
);

export const getZones = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/zone`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getGrassTypes = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/grasstype`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postGrassTypes = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/grasstype`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('grassType.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('grassType.errorNew'),
    })
  })
);

export const editGrassTypes = (data, grassId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/grasstype/${grassId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('grassType.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('grassType.errorEdit'),
    })
  })
);

export const getFacilityTypes = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/facilitytype`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postFacilityTypes = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/facilitytype`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('facility.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('facility.errorNew'),
    })
  })
);

export const editFacilityTypes = (data, facilityId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/facilitytype/${facilityId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('facility.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('facility.errorEdit'),
    })
  })
);

export const uploadFacilityBackground = (facility_type_id, formData, type_bg, percentCompleted) => (
  UploadService().put(`${VUE_APP_API_COURSE}/facilitytype/${facility_type_id}/${type_bg}`, formData, {
    onUploadProgress: progressEvent => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  })
);
export const uploadNewFacilityBackground = (formData, type_bg, percentCompleted) => (
  UploadService().post(`${VUE_APP_API_COURSE}/facilitytype/${type_bg}`, formData, {
    onUploadProgress: progressEvent => {
      if (percentCompleted && percentCompleted.constructor === Function) {
        percentCompleted(Math.round((progressEvent.loaded * 100) / progressEvent.total));
      }
    }
  })
);

export const saveGrassToZone = (zone_id, grass_type_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/zone/${zone_id}/grasstype/${grass_type_id}`,
    method: 'post',
    body: null,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('grassType.successMove'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('grassType.errorMove'),
    })
  })
);

export const removeGrassToZone = (zone_id, grass_type_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/zone/${zone_id}/grasstype/${grass_type_id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('grassType.successMove'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('grassType.errorMove'),
    })
  })
);

export const getCourses = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getCourseById = (courseId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${courseId}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getStationData = (device_sn , {limit, next}) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/${device_sn}/data?limit=${limit ? limit : ''}&next=${next ? encodeURI(next) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getLocalWeatherData = (course_id , {limit, next}) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/weather/local/data?limit=${limit ? limit : ''}&next=${next ? encodeURI(next) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getStationGraph = (data) => {
  let url =`${VUE_APP_API_COURSE}/weather/station/${data.device_sn}/graph/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`
  if (data.startDate && data.endDate){
    url= `${VUE_APP_API_COURSE}/weather/station/${data.device_sn}/graph/between-dates/all?from_date=${data.startDate}&until_date=${data.endDate}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`
  }
  return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}

export const getWeatherStationsReportList = (data) => {
  let url = `${VUE_APP_API_COURSE}/${data.courseId}/report/weather/stations`
  return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}

export const getWeatherStationsReportGraphData = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${data.courseId}/report/graph/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getAllWeatherStationsReportList = (data) => {
  let url = `${VUE_APP_API_COURSE}/all/report/weather/stations` 
  return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}

export const getAllWeatherStationsReportGraphData = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/all/report/graph/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const courseMonitoring = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/monitoring`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

export const externalMonitoring = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/monitoring/external`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

export const getAllCoursesReport = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/report/all`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const sendSensorOutOfGroundNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/facilitymaintenance`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.outOfGround'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.outOfGroundError'),
    })
  })
);

export const sendSensorOutOfGroundClearNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/notfacilitymaintenance`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.outOfGroundSucces'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.outOfGroundError'),
    })
  })
);

export const sendSensorDamagedNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/damaged`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.damaged'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.damagedError'),
    })
  })
);

export const sendSensorDamagedClearNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/notdamaged`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.damagedSucces'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.damagedError'),
    })
  })
);

export const sendSensorInspectionNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/inspection`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.inspection'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.outOfGroundError'),
    })
  })
);

export const sendSensorInspectionClearNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/notinspection`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.damagedSucces'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.outOfGroundError'),
    })
  })
);

export const sendLateSensorNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/latesensor`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.lateSensor'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.outOfGroundError'),
    })
  })
);

export const sendLateSensorClearNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/notlatesensor`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.damagedSucces'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.outOfGroundError'),
    })
  })
);

export const sendSensorOffNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/off`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.off'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.offError'),
    })
  })
);

export const sendSensorOffClearNotification = (course_id, sensor_id) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${course_id}/sensor/${sensor_id}/notoff`,
    method: 'post',
    body: {},
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('sensors.offSucces'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('sensors.offError'),
    })
  })
);

export const deleteFacility = (courseId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/${courseId}/delete`,
    method: 'delete',
    body: {},
    showError: true,
    errorList: { 
      '10': Consts.Context.APP.$t('courses.noDeleteSensors'),
      '401': Consts.Context.APP.$t('courses.noDeleteStations'),
      '7': Consts.Context.APP.$t('courses.noDeleteUsers'),
    },
  })
);

export const getManagementCompanies = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/management-company`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postManagementCompany = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/management-company`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('managementCompanies.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('managementCompanies.errorNew'),
    })
  })
);

export const editManagementCompany = (data, companyId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/management-company/${companyId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('managementCompanies.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('managementCompanies.errorEdit'),
    })
  })
);

export const getAgents = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/agent`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postAgents = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/agent`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('agents.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('agents.errorNew'),
    })
  })
);

export const editAgents = (data, agentId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/agent/${agentId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('agents.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('agents.errorEdit'),
    })
  })
);

export const getTreeTypes = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/treetype`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postTreeTypes = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/treetype`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('treeType.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('treeType.errorNew'),
    })
  })
);

export const editTreeTypes = (data, treeTypeId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/treetype/${treeTypeId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('treeType.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('treeType.errorEdit'),
    })
  })
);

export const getSoilTypes = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/soil-type`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postSoilTypes = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/soil-type`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('soilType.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('soilType.errorNew'),
    })
  })
);

export const editSoilTypes = (data, soilTypeId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/soil-type/${soilTypeId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('soilType.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('soilType.errorEdit'),
    })
  })
);

export const getPlantTypes = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/planttype`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postPlantTypes = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/planttype`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('plantType.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('plantType.errorNew'),
    })
  })
);

export const editPlantTypes = (data, plantTypeId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/planttype/${plantTypeId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('plantType.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('plantType.errorEdit'),
    })
  })
);

export const getShrubs = () => (
  Http({
    url: `${VUE_APP_API_COURSE}/shrubtype`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postShrubs = (data) => (
  Http({
    url: `${VUE_APP_API_COURSE}/shrubtype`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('shrub.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('shrub.errorNew'),
    })
  })
);

export const editShrubs = (data, shrubId) => (
  Http({
    url: `${VUE_APP_API_COURSE}/shrubtype/${shrubId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('shrub.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('shrub.errorEdit'),
    })
  })
);

export const getStationMinMaxTemps = (device_sn) => (
  Http({
    url: `${VUE_APP_API_COURSE}/weather/station/min-max/${device_sn}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

// ------------------------------------------- End Golf-Course Services ----------------------------




// ------------------------------------------- Start Sensor services ----------------------------
const VUE_APP_API_SENSOR = process.env.VUE_APP_API_SENSOR;

export const activateSensor = (id, data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/activate`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { '200': Consts.Context.APP.$t('sensor.sensorStatusError') },
  })
);

export const updateSensor = (id, data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { '200': Consts.Context.APP.$t('sensor.sensorStatusError') },
  })
);

export const editProvisionedSensor = (id, data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/provisioned`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { '200': Consts.Context.APP.$t('sensor.sensorStatusError') },
  })
);

export const editProvisionedSensorPass = (id, data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/provisioned-password`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { '1': Consts.Context.APP.$t('settings.wrongPassword'), },
  })
);

export const saveSensors = (courseId, sensors) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/course/${courseId}`,
    method: 'post',
    body: sensors,
    showError: true,
    errorList: { },
  })
);

export const deleteSensors = (courseId, sensors) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/course/${courseId}`,
    method: 'delete',
    body: sensors,
    showError: true,
    errorList: { },
  })
);

export const getSensors = (courseId) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/bycourse/${courseId ? courseId : returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensor = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorData = (id , {limit, next}) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${id}/data?limit=${limit ? limit : ''}&next=${next ? encodeURI(next) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorLogs = (serial_number , {limit, next}) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${serial_number}/logs?limit=${limit ? limit : ''}&next=${next ? encodeURI(next) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorsByHole = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/byhole/${id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorsByZone = (course_id, zone_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/byzone/${course_id}/${zone_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getThresholdPresets = (id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/threshold/preset/bycourse/${returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const updateThreshold = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/threshold/`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  })
);

export const updateSingleThreshold = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/threshold/single`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  })
);

export const getAlertByCourse = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alert/bycourse/${returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetOpenedAlertByCourse = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alert/opened/bycourse/${returnCourse().course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetOpenedAlertBySensor = (sensor_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensor_id}/alert/opened`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const GetOpenedAlertByStation = (station_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alert/station/${station_id}/opened`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getRssiRanges = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/rssi`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);
export const getSensorGraph = (data) => {
  let url = `${VUE_APP_API_SENSOR}/${data.sensorId}/graph/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`
  
  if (data.startDate && data.endDate) {
    url = `${VUE_APP_API_SENSOR}/${data.sensorId}/graph/between-dates/${data.alias}?start_date=${data.startDate}&end_date=${data.endDate}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`
  }
   return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}
export const cleanUpSensor = (sensorId, password, clearData) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensorId}/clean-up`,
    method: 'put',
    body: {password: password, check_cleanup: clearData},
    showError: true,
    errorList: { 
      '1': Consts.Context.APP.$t('settings.wrongPassword'),
    },
  })
);

export const getSensorRingGraph = (sensorId) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensorId}/ring-graph`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getAvailableSensors = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/factory/available`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const hideSensor = (sensorId, hidden) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${sensorId}/hide`,
    method: 'put',
    body: {"hidden": hidden},
    showError: true,
    errorList: { },
  })
);

export const saveSensorCommand = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/command/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  })
);
export const deleteSensorCommand = (request_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/command/${request_id}`,
    method: 'delete',
    body: null,
    showError: true,
    errorList: { },
  })
);
export const getSensorCommands = (sensor_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/command/bysensor/${sensor_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getCourseBLECommands = (course_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/blecommand/bycourse/${course_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getOTAVersion = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/command/ota/version`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getOTABLEVersion = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/command/ota/ble/version`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorAlertsReport = (data) => {
  
  let url = `${VUE_APP_API_SENSOR}/alerts-report/bycourse/${data.courseId}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`
  if (data.startDate && data.endDate) {
    
    url = `${VUE_APP_API_SENSOR}/alerts-report/bycourse/${data.courseId}/between?start_date=${data.startDate}&end_date=${data.endDate}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`
  }

  return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}

export const getWeatherAlertsReport = (data) => {
  let url = `${VUE_APP_API_COURSE}/ws-alerts-report/bycourse/${data.courseId}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`;

  if (data.startDate && data.endDate) {
    
    url = `${VUE_APP_API_COURSE}/ws-alerts-report/bycourse/between-dates/${data.courseId}?from_date=${data.startDate }&until_date=${data.endDate}`
  }

  return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}

export const getSensorsReportFilters = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/report/filtersbycourse/${data.courseId}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorsReportList = (data) => {

  let url = `${VUE_APP_API_SENSOR}/report/bycourse/${data.courseId}`;

  if (data.startDate && data.endDate) {
    url = `${VUE_APP_API_SENSOR}/report/bycourse/${data.courseId}?start_date=${data.startDate}&end_date=${data.endDate}`;
  }

  return Http({
    url,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
}
  


export const getSensorsReportGraphData = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/report/graphbycourse/${data.courseId}/${data.alias}?until=${data.until}${data.resampleFreq ? ('&resampleFreq=' + data.resampleFreq) : ''}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const sensorMonitoring = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/monitoring`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

export const iotMonitoring = () => (
  Http({
    url: `${VUE_APP_API_SENSOR}/monitoring/iot`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

export const getSensorsInventoryReport = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/report/inventory`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getOpenCommFailAlerts = (data) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/alerts/communication-failure/open`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getSensorLogsByRequest = (serial_number, request_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/${serial_number}/logs/request/${request_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const getDailyTemps = (sensor_id) => (
  Http({
    url: `${VUE_APP_API_SENSOR}/sensor-daily-readings/${sensor_id}`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

// ------------------------------------------- END Sensor services ----------------------------

// ------------------------------------------- START Task services ----------------------------
const VUE_APP_API_TASK = process.env.VUE_APP_API_TASK;

export const getTasks = (pagination) => (
  Http({
    url: `${VUE_APP_API_TASK}/search`,
    method: 'post',
    body: pagination,
    showError: true,
    errorList: {},
  })
);
export const getActiveTasks = () => (
  Http({
    url: `${VUE_APP_API_TASK}/active/course/${returnCourse().course_id}`,
    method: 'get',
    showError: true,
    errorList: {},
  })
);
export const saveTask = (data) => (
  Http({
    url: `${VUE_APP_API_TASK}/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('tasks.taskCreated'),
    });
    return response;
  })
);

export const updateTask = (data, taskId, showSuccessMessage) => (
  Http({
    url: `${VUE_APP_API_TASK}/${taskId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    if (showSuccessMessage) {
      Vue.notify({
        type: 'success',
        text: Consts.Context.APP.$t('tasks.taskUpdated'),
      });
    }
    return response;
  })
);

export const updateTaskStatus = (data, taskId) => (
  Http({
    url: `${VUE_APP_API_TASK}/${taskId}/status`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    return response;
  })
);

export const SearchTasks = (payload) => (
  Http({
    url: `${VUE_APP_API_TASK}/search`,
    method: 'post',
    body: payload,
    showError: true,
    errorList: { },
  })
);

export const DeleteTask = (taskId) => (
  Http({
    url: `${VUE_APP_API_TASK}/${taskId}`,
    method: 'delete',
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('tasks.taskDeleted'),
    });
    return response;
  })
);

export const saveTaskComment = (data) => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  })
);

export const DeleteTaskComment = (taskId) => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/${taskId}`,
    method: 'delete',
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('tasks.commentDeleted'),
    });
    return response;
  })
);
export const getTask = (taskId) => (
  Http({
    url: `${VUE_APP_API_TASK}/${taskId}`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);
export const getMessages = () => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/recent/bycourse/${returnCourse().course_id}`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);
export const getCountMessages = () => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/not-seen/bycourse/${returnCourse().course_id}`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);
export const updateCountMessages = () => (
  Http({
    url: `${VUE_APP_API_TASK}/activity/seen/bycourse/${returnCourse().course_id}`,
    method: 'put',
    showError: true,
    errorList: { },
  })
);

export const taskMonitoring = () => (
  Http({
    url: `${VUE_APP_API_TASK}/monitoring`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

export const getActivities = () => (
  Http({
    url: `${VUE_APP_API_TASK}/activity-list`,
    method: 'get',
    body: null,
    showError: true,
    errorList: { },
  })
);

export const postActivities = (data) => (
  Http({
    url: `${VUE_APP_API_TASK}/activity-list`,
    method: 'post',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('activities.successNew'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('activities.errorNew'),
    })
  })
);

export const editActivities = (data, activityId) => (
  Http({
    url: `${VUE_APP_API_TASK}/activity-list/${activityId}`,
    method: 'put',
    body: data,
    showError: true,
    errorList: { },
  }).then((response) => {
    Vue.notify({
      type: 'success',
      text: Consts.Context.APP.$t('activities.successEdit'),
    });
    return response;
  }).catch((err)=>{
    Vue.notify({
      type: 'error',
      text: Consts.Context.APP.$t('activities.errorEdit'),
    })
  })
);

export const getTaskReport = (courseId, until) => (
  Http({
    url: `${VUE_APP_API_TASK}/report/bycourse/${courseId}?until=${until}`,
    method: 'get',
    showError: true,
    errorList: { },
  })
);

// ------------------------------------------- END Task services ----------------------------